import React from 'react';
import { isMobileOnly } from 'mobile-device-detect';
import { useTextResources } from '../../language';
import { PropTypes } from 'prop-types'
import { Modal, Form, Button } from 'semantic-ui-react';
import RoomExpensesDDL from '../../components/shared/RoomExpensesDropDown';
import TextInput from '../../components/shared/TextInput';
import NumericInput from '../../components/shared/NumericInput';
import RoomsDropDown from '../../components/shared/RoomsDropDown';
import { DatePicker } from '../../components/shared/DatePicker';
import moment from 'moment';
import CurrencyDropDown from '../../components/shared/CurrencyDropDown';
export const RowEditModal = ({
    extendedProps: {
        expenseTypes,
        rooms,
        updateRow,
        addRow
    },
    row,
    onChange,
    onApplyChanges,
    onCancelChanges,
    open,
}) => {
    const text = useTextResources();
    const isEdit = row.Id > 0 || row.newExpenseTempId < 0;
    

    if (row.CurrencyAmount === 0 && !row.Date && !row.CreateDate) {
        onChange("Date", moment().startOf('day'));
        onChange("CreateDate", moment().startOf('day'));
    }

    const isSaveDisabled = () =>{
        return !(row.Name && row.CurrencyId && row.CurrencyAmount >=0 && row.Date && row.CreateDate && row.RoomExpenseTypeId && row.RoomId);
    }

    const changeExpenseTypeHandler = (value) => {
        var selectedExpenseType = expenseTypes.find(x => x.Id == value);
        if (selectedExpenseType) {
            onChange("Name", selectedExpenseType.Name);
            onChange("RoomExpenseTypeId", selectedExpenseType.Id);
            onChange("CurrencyAmount", selectedExpenseType.CurrencyAmount);
            onChange("CurrencyId", selectedExpenseType.CurrencyId);
        }
    }

    const applyChanges = () => {
        if(isEdit){
            updateRow(row)
        }
        else{
            addRow(row);
        }
        onApplyChanges();
    };

    const processValueChange = () => {
        if(isEdit){
            updateRow(row)
        }
        else{
            addRow(row);
        }
    };

    return (
        <Modal
            size={isMobileOnly ? 'fullscreen' : 'tiny'}
            className={isMobileOnly ? 'mobile' : ''}
            open={open}
            style={{ zIndex: 1000000 }}
        >
            {!isMobileOnly && <Modal.Header>{text('ExpensesManagement')}</Modal.Header>}
            <Modal.Content
                style={isMobileOnly ? { overflowY: 'auto' } : { maxHeight: 600 }}
            >
                <Form size='small'>
                    <Form.Group
                        unstackable
                        widths={'equal'}
                        style={{ flexWrap: 'wrap', gap: '1em' }}
                        >
                        <Form.Field label={`${text("Name")}`}
                            control={RoomExpensesDDL}
                            value={row.RoomExpenseTypeId}
                            data={expenseTypes}
                            onChange={changeExpenseTypeHandler} />
                        <Form.Field label={`${text("Description")}`}
                            control={TextInput}
                            value={row.Name}
                            onChange={onChange.bind(null, 'Name')} />
                        <Form.Field label={`${text("Room")}`}
                            control={RoomsDropDown}
                            data={rooms}
                            value={row.RoomId}
                            onChange={onChange.bind(null, 'RoomId')} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Field label={`${text("Amount")}`}
                            width={8}
                            control={NumericInput} digits={0} min={0}
                            value={row.CurrencyAmount}
                            onChange={onChange.bind(null, 'CurrencyAmount')} />
                        <Form.Field label={`${text("Currency")}`}
                            width={8}
                            control={CurrencyDropDown} fluid
                            value={row.CurrencyId}
                            onChange={onChange.bind(null, 'CurrencyId')} />
                    </Form.Group>
                    <Form.Group unstackable className='date-pick-group' >
                        <Form.Field label={`${text("Date")}`}
                            control={DatePicker}
                            value={moment(row.Date).toDate()}
                            onChange={onChange.bind(null, 'Date')}
                            clearable={false} />
                        <Form.Field label={`${text("CreateDate")}`}
                            control={DatePicker}
                            value={moment(row.CreateDate).toDate()}
                            onChange={onChange.bind(null, 'CreateDate')}
                            clearable={false} />

                    </Form.Group>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    size={isMobileOnly ? 'tiny' : 'small'}
                    negative
                    onClick={onCancelChanges}
                >
                    {text('Cancel')}
                </Button>
                <Button
                    size={isMobileOnly ? 'tiny' : 'small'}
                    disabled={isSaveDisabled()}
                    positive
                    onClick={applyChanges}
                >
                    {text('Saveandclose')}
                </Button>
                <Button
                    size={isMobileOnly ? 'tiny' : 'small'}
                    disabled={isSaveDisabled()}
                    positive
                    onClick={processValueChange}
                >
                    {text('Apply')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

RowEditModal.propTypes = {
    extendedProps: PropTypes.object,
    row: PropTypes.object,
    onChange: PropTypes.func,
    onApplyChanges: PropTypes.func,
    processValueChange: PropTypes.func,
    onCancelChanges: PropTypes.func,
    open: PropTypes.bool,
    onDeleteRow: PropTypes.func,
};